import styled from 'styled-components';

interface SideBarOptionProps {
  isActive: boolean;
}

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 25px;
  padding-bottom: 8px;
  margin-bottom: 20px;
  border-bottom: 1px solid #777777;

  .react-datepicker {
    border: none;
    box-shadow: -2px 3px 6px rgba(0, 0, 0, 0.1),
      -10px 15px 20px rgba(111, 111, 111, 0.1);
  }

  .react-datepicker__day--keyboard-selected {
    background-color: white;
    color: black;
  }

  .react-datepicker__input-container {
    input {
      border: none;
      background-color: white;
    }
  }

  .react-datepicker__day--selected,
  .react-datepicker__day--range-end {
    border-radius: 10px;
  }

  .react-datepicker__day--in-range {
    background-color: rgba(255, 153, 184, 0.25);
    border-radius: 0;
    color: #1a1a1a;
  }

  .react-datepicker__day--in-selecting-range {
    background-color: rgba(255, 153, 184, 0.25);
    color: #1a1a1a;
  }

  .react-datepicker__day--selecting-range-start {
    background-color: #eb0045;
    color: #fff;
    border-radius: 10px 0 0 10px;
  }

  .react-datepicker__header {
    background-color: #fff;
    border-bottom: none;
  }

  .react-datepicker__current-month {
    color: #eb0045;
    font-size: 14px;
  }

  .react-datepicker__current-month::first-letter {
    text-transform: capitalize;
  }

  .react-datepicker__day-names {
    .react-datepicker__day-name {
      color: #b2b2b2;
    }
  }

  .react-datepicker__day {
    font-size: 12px;
    padding: 10px;
    width: 42px;
    height: 42px;
    margin: 0;
  }

  .react-datepicker__day-names {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 15px;
    margin-top: 12px;
    font-size: 12px;
  }

  .react-datepicker__day--range-start {
    background-color: #eb0045;
    border-radius: 10px 0 0 10px;
    color: #fff;
    text-align: center;
  }

  .react-datepicker__day--range-end {
    background-color: #eb0045;
    color: #fff;
    border-radius: 0 10px 10px 0;
  }

  .react-datepicker__day--selected {
    border-radius: 10px 0 0 10px;
  }

  .react-datepicker__day-name {
    :nth-child(1) {
      &:after {
        visibility: visible;
        position: relative;
        text-align: center;
        left: 3px;
        content: 'D';
      }
    }
    :nth-child(2) {
      &:after {
        visibility: visible;
        position: relative;
        left: 3px;
        text-align: center;
        content: 'S';
      }
    }
    :nth-child(3) {
      &:after {
        visibility: visible;
        position: relative;

        text-align: center;
        content: 'T';
      }
    }
    :nth-child(4) {
      &:after {
        visibility: visible;
        position: relative;

        text-align: center;
        content: 'Q';
      }
    }
    :nth-child(5) {
      &:after {
        visibility: visible;
        position: relative;
        left: -2px;
        text-align: center;
        content: 'Q';
      }
    }
    :nth-child(6) {
      &:after {
        visibility: visible;
        position: relative;
        left: -3px;
        text-align: center;
        content: 'S';
      }
    }
    :nth-child(7) {
      &:after {
        visibility: visible;
        position: relative;
        left: -5px;
        text-align: center;
        content: 'S';
      }
    }
  }

  .react-datepicker__day--outside-month {
    opacity: 0;
    pointer-events: none;
  }

  .react-datepicker__day--range-start.react-datepicker__day--range-end {
    border-radius: 50%;
  }
`;

export const CalendarContainer = styled.div`
  padding: 16px 0;
  background: #fff;
  color: #fff;
  display: flex;
  flex-direction: row;
  box-shadow: -2px 3px 6px rgba(0, 0, 0, 0.1),
    -10px 15px 20px rgba(111, 111, 111, 0.1);
  margin-top: 8px;
`;

export const SideBar = styled.div`
  display: flex;
  flex-direction: column;
  gap: 26px;
  border-left: 1px solid #f4f4f4;
  padding: 3px 18px 0 16px;
`;

export const SideBarOption = styled.button<SideBarOptionProps>`
  border: 1px solid #f4f4f4;
  background: ${(props) => (props.isActive ? '#eb0045' : 'none')};
  border-radius: 52px;
  padding: 3px 16px 5px 16px;
  color: ${(props) => (props.isActive ? '#ffffff' : ' #4d4d4d')};

  &:hover {
    background-color: #eb0045;
    color: #ffffff;
  }
`;

export const InputContainer = styled.button`
  display: flex;
  background: none;
  border: none;

  input {
    &:disabled {
      cursor: pointer;
    }
  }
`;
